import React from "react";
import { Context, StoresContext } from "../context";

export const useStores = (): StoresContext => React.useContext(Context);
